module.exports = __webpack_public_path__ + "static/media/class_pink.89543360.svg";